import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from 'vuex-persistedstate'
import configs from './configs'
import session from './session'
import mashup from './mashup'
import banners from './banners'
import rbac from './rbac'
import env from './env'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    configs,
    env,
    rbac,
    session,
    mashup,
    banners,
  },
  plugins: [createPersistedState({
    paths: [
      'configs',
      'rbac',
      'session',
    ],
  })],
})
